module.exports = __webpack_public_path__ + "img/products2.0d5a7627.jpg";